import { reactive } from 'vue';

/**
 * 簡單的事件發射器，用於組件間通信
 */
const eventBus = reactive( {
    events: {},
} );

export default function useEmitter () {
    /**
     * 註冊事件監聽
     * @param {string} event - 事件名稱
     * @param {Function} callback - 回調函數
     */
    const on = ( event, callback ) => {
        if ( !eventBus.events[ event ] ) {
            eventBus.events[ event ] = [];
        }
        eventBus.events[ event ].push( callback );
    };

    /**
     * 移除事件監聽
     * @param {string} event - 事件名稱
     * @param {Function} [callback] - 可選的回調函數，如果不提供則移除該事件的所有監聽
     */
    const off = ( event, callback ) => {
        if ( !eventBus.events[ event ] ) return;

        if ( !callback ) {
            delete eventBus.events[ event ];
        } else {
            eventBus.events[ event ] = eventBus.events[ event ].filter(
                ( cb ) => cb !== callback
            );
        }
    };

    /**
     * 觸發事件
     * @param {string} event - 事件名稱
     * @param {any} [payload] - 可選的事件資料
     */
    const emit = ( event, payload ) => {
        if ( !eventBus.events[ event ] ) return;

        eventBus.events[ event ].forEach( ( callback ) => {
            callback( payload );
        } );
    };

    return {
        on,
        off,
        emit,
    };
} 